export default {
    data() {
        return {
            serviceTypeList: [], // 服务类别
            selectServiceTypeList: [], // 新增时  服务类别选项
            selectserviceModeList: [], // 新增时  服务提供方式选项
            serviceModeList: [], // 服务提供方式
            supplierDataList: [], // 供应商列表
        }
    },
    methods: {
        /**
        * 获取服务类别列表
        */
        async getServiceType() {
            const res = await this.axios.get(
                this.getApiUrl("serviceTypeTree"),
                {}
            );
            if (res.code === 1) {
                this.editList(res.data);
                this.serviceTypeList = res.data;
                this.selectServiceTypeList = JSON.parse(JSON.stringify(res.data));
                this.selectServiceTypeList.forEach((item) => {
                    if(!item.children) item.disabled = true
                })
            } else {
                this.$message.warning(res.msg);
            }
        },
        /**
         * 获取服务提供方式列表
         */
        async getserviceModeList() {
            const res = await this.axios.get(
                this.getApiUrl("serviceModeTree"),
                {}
            );
            if (res.code === 1) {
                this.editList(res.data);
                this.serviceModeList = res.data;
                this.selectserviceModeList = JSON.parse(JSON.stringify(res.data));
                this.selectserviceModeList.forEach((item) => {
                    if(!item.children) item.disabled = true
                })
            } else {
                this.$message.warning(res.msg);
            }
        },
        editList(list) {
            if (list?.length) {
                list.forEach((data) => {
                    if (data?.children?.length) {
                        this.editList(data.children);
                    } else if (data?.children?.length === 0) {
                        data.children = undefined;
                    }
                });
            }
        },
        /**
         * 获取供应商列表
         */
        async getSupplierList() {
            let res = await this.axios.get(this.getApiUrl("providerPage"), {
            params: {
                pageNo: 1,
                pageSize: 1000,
            },
            });
            this.supplierDataList = res?.data?.data || [];
        },
    },
    mounted() {
        this.getSupplierList();
        this.getServiceType();
        this.getserviceModeList();
    },
}